import { useHistory, useRouteMatch, useLocation } from "react-router-dom";
import { isBookmarkComplete } from "../../../shared/utils";
import PlayerConstants from "../../../shared/constants/player";

const { PLAYER_TYPE: LIVE } = PlayerConstants;

const usePlaybackParams = () => {
  const history = useHistory();
  const match = useRouteMatch();
  const location = useLocation();

  const playbackType = match.params.playbackType ?? LIVE;
  const query = new URLSearchParams(location.search);
  const playbackID = query.get("playbackId");
  const externalId = query.get("externalId");
  const channelID = query.get("stationId");
  const stopDeltaTime = query.get("stopDeltaTime");
  const contentType = query.get("contentType") ?? (channelID ? "LIVE" : "VOD");
  const isLookback = query.get("isLookback") ? JSON.parse(query.get("isLookback")) : false;
  const playbackContent = location?.state?.playbackContent;
  const playbackVideoUrl = playbackContent?.videoUrl;
  const playbackAuthToken = playbackContent?.authToken;
  const playbackBookmark = isBookmarkComplete(playbackContent?.bookmark) ? null : playbackContent?.bookmark;
  const playbackSkipTimeSeconds = playbackContent?.skipTimeSeconds;
  const playbackAssetId = playbackContent?.assetId;
  const playbackPcPin = query.get("pcPin") || playbackContent?.pcPin;
  const isLivePlayer = contentType === "LIVE";
  const isVodPlayer = contentType === "VOD";
  const isRecordingPlayer = contentType === "RECORDING";

  return {
    history,
    playbackType,
    playbackID,
    externalId,
    channelID,
    contentType,
    isLookback,
    playbackContent,
    playbackVideoUrl,
    playbackAuthToken,
    playbackBookmark,
    playbackSkipTimeSeconds,
    playbackAssetId,
    playbackPcPin,
    isLivePlayer,
    isVodPlayer,
    isRecordingPlayer,
    stopDeltaTime,
  };
};

export default usePlaybackParams;
